export const SocialType = {
  Google: 'google',
  Facebook: 'facebook',
  Apple: 'apple',
  Twitter: 'twitter',
  Instagram: 'instagram',
  Metamask: 'metamask',
  Xaman: 'xaman',
  Reddit: 'reddit',
  LinkedIn: 'linkedIn',
};

export const socialTypeLabel = {
  [SocialType.Facebook]: 'Facebook',
  [SocialType.Twitter]: 'X',
  [SocialType.LinkedIn]: 'LinkedIn',
  [SocialType.Reddit]: 'Reddit',
};

export const StoreType = {
  Google: 'google',
  Apple: 'apple',
};
export const redirectStoreUrl = {
  [StoreType.Google]: process.env.REACT_APP_GOOGLE_STORE_URL
    || 'https://play.google.com/store/apps/dev?id=6277972975348815960',
  [StoreType.Apple]: process.env.REACT_APP_APPLE_STORE_URL
    || 'https://apps.apple.com/in/developer/igc-marketing-pty-ltd/id1581839937',
};